export default function handleUnsubscribe(params) {
  const encodedEmail = params.get("emailId") || "";

  const emailId = encodedEmail ? decodeURIComponent(atob(encodedEmail)) : "";

  return {
    action: "unsubscribe",
    emailId,
  };
}
